import React from 'react';
import type { AttentionPriority } from '../../../receptionist-dashboard/types';

const CONFIG: Record<
  AttentionPriority,
  { bg: string; color: string; label: string }
> = {
  urgent: { bg: 'var(--terracotta-tint)', color: 'var(--terracotta)', label: 'Urgent' },
  high: { bg: 'var(--gold-tint)', color: 'var(--gold)', label: 'High' },
  medium: { bg: 'var(--cream-1)', color: 'var(--ink-2)', label: 'Medium' },
};

export interface PriorityBadgeProps {
  priority: AttentionPriority;
}

export function PriorityBadge({ priority }: PriorityBadgeProps) {
  const cfg = CONFIG[priority] ?? CONFIG.medium;
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded px-2 py-0.5 font-[var(--font-mono)] text-[10px] font-bold uppercase tracking-[0.08em]"
      style={{ background: cfg.bg, color: cfg.color }}
    >
      <span className="h-[5px] w-[5px] rounded-full" style={{ background: cfg.color }} />
      {cfg.label}
    </span>
  );
}
